const userConfig = {
  name: 'User',
  endpoint: '/internal_admin/admin_kit/users',
  titleField: 'email',

  columns: [
    { name: 'username', title: 'Username', type: 'link' },
    { name: 'email', title: 'Email' },
    { name: 'first_name', title: 'First Name' },
    { name: 'last_name', title: 'Last Name' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[username_cont]', label: 'Username' },
    { name: 'q[email_cont]', label: 'Email' },
    { name: 'q[first_name_cont]', label: 'First Name' },
    { name: 'q[last_name_cont]', label: 'Last Name' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'username', label: 'Username' },
    { name: 'email', label: 'Email' },
    { name: 'first_name', label: 'First Name' },
    { name: 'last_name', label: 'Last Name' },
    { name: 'phone', label: 'Phone' },
    { name: 'mobile', label: 'Mobile' },
    { name: 'job_role', label: 'Job Role' },
    { name: 'title', label: 'Title' },
    { name: 'timezone', label: 'Timezone' },
    { name: 'locale', label: 'Locale' },
    { name: 'notes', label: 'Notes' },
    { name: 'dms_id', label: 'DMS ID' },
    { name: 'user_uri', label: 'User URI' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  showActions: [
    {
      text: 'Become',
      kind: 'secondary',
      confirmTitle: 'Become User',
      confirmBody: (record) =>
        `You will be logged in as "${record.email}". Your current admin session will end.`,
      confirmText: 'Become',
      endpoint: (record) => `/users/${record.id}/become`,
      method: 'POST',
      redirectTo: '/',
    },
  ],
};

export default userConfig;
